import { useEffect } from 'react';

import { useAppDispatch, useAppSelector } from 'app/hooks';
import { extractStatusCode } from 'common/services/api/apiHelpers';
import { fetchUserProfileAclsAndLicenses } from 'common/services/api/UserProfileAcls/UserProfileAcls.thunk';
import { handleListFetchError } from 'common/utils/errorHandlers';
import { IUserProfileTenant } from 'features/userProfileApps/UserProfileApps';
import { useSnackbar } from 'notistack';

import { selectProcessingUserProfileAclsWithLicense,selectUserProfileAclsWithLicenseByTenantId } from '../userProfileAclsSlice';

export const useFetchUserProfileAclsWithLicenseInfo = (
    tenant: IUserProfileTenant,
    userId: string
) => {
    const { id: tenantId, isLicenseRequired } = tenant;
    const userProfileAclsWithLicense = useAppSelector(selectUserProfileAclsWithLicenseByTenantId(tenantId));
    const processingUserProfileAclsWithLicense = useAppSelector(selectProcessingUserProfileAclsWithLicense);
    const dispatch = useAppDispatch();
    const { enqueueSnackbar } = useSnackbar();

    useEffect(() => {
        if (userProfileAclsWithLicense) {
            return;
        }
        if (isLicenseRequired) {
            dispatch(fetchUserProfileAclsAndLicenses({ currentUserProfileTenant: tenant, userId }))
                .catch((error) => {
                    handleListFetchError(extractStatusCode(error.message), 'User Profile Acl Entries With License', enqueueSnackbar);
                });
        }
    }, [tenantId, userId, isLicenseRequired]);

    return {
        userProfileAclsWithLicense,
        processingUserProfileAclsWithLicense: processingUserProfileAclsWithLicense === tenantId
    };
};
